export default __webpack_public_path__ + "d7616e1cf3c64b193bf8a2ea08044e17.svg";